<template>
    <div class="convention-ca-territory">
        <convention-body v-if="territory.type == 'text'" :body="territory.body" />
        <div class="convention-body" v-if="territory.type == 'group'">
            <table v-if="items && items.length > 0">
                <tr>
                    <th class="code">{{ dico.departement }}</th>
                    <th>{{ dico.territoire }}</th>
                </tr>
                <convention-ca-territory-item
                    v-for="item in items"
                    :item="item"
                    :key="item._uid"
                    :territories="territories"
                />
            </table>
        </div>
    </div>
</template>

<script>
import ConventionCaTerritoryItem from "./ConventionCaTerritoryItem.vue";
import ConventionBody from "src/components/convention/ConventionBody.vue";

import { filter } from "lodash";

export default {
    components: { ConventionBody, ConventionCaTerritoryItem },
    props: ["territory", "territories"],
    computed: {
        items() {
            return filter(
                this.territory.items,
                item => item.code !== "met" && item.code !== "all" && item.code !== "dom"
            );
        },
        dico() {
            return this.$privateDico.convention.ca;
        },
    },
};
</script>

<style scoped lang="sass">
.code
    width: 20%
</style>
